import { connect, useForm } from "@formily/react";
import { Debug as DebugComponent } from "../Debug";
import { getConfigValue } from "@rumble-it/common-lib/src/config";

export const Debug = connect((props) => {
  if (
    getConfigValue("mode") !== "acceptance" &&
    getConfigValue("mode") !== "development"
  ) {
    return null;
  }

  const form = useForm();
  return (
    <DebugComponent
      data={form.values}
      initialCollapsed={true}
      title="Form Values"
      {...props}
    />
  );
});
